<template>
    <div class="team">
        <div class="banner">
            <div class="banner-text">MEET OUR LEADERSHIP TEAM</div>
            <img src="@/assets/team/banner.jpg"/>
        </div>
        <div class="message-box">
            <div class="first">
                <div class="item">
                    <div class="item-user">
                        <img src="@/assets/team/user.png"/>
                        <div class="name">
                            <span>Emma Carter</span>
                            <div class="bg"/>
                        </div>
                        <div class="bg-color"/>
                        <div class="bg-name-color"/>
                    </div>
                    <div class="title">Founder & CEO</div>
                    <div class="note">Emma is a visionary entrepreneur with over 15 years of experience in construction technology and project management. She founded BuildEffi AI to address inefficiencies in the construction industry through innovative AI solutions. Emma holds a Master's degree in Civil Engineering from Stanford University and an MBA from Harvard Business School.</div>
                </div>
            </div>
            <div class="info">
                <div class="item">
                    <div class="item-user">
                        <img src="@/assets/team/user-1.png"/>
                        <div class="name">
                            <span>Liam Johnson</span>
                            <div class="bg"/>
                        </div>
                        <div class="bg-color"/>
                        <div class="bg-name-color"/>
                    </div>
                    <div class="title">Co-Founder & Chief Technology Officer (CTO)</div>
                    <div class="note">Liam is an AI expert with extensive experience in machine learning and data analytics. Before co-founding BuildEffi AI, he led AI development teams for Fortune 500 companies. Liam holds a Ph.D. in Artificial Intelligence from MIT and is passionate about using technology to revolutionize traditional industries.</div>
                </div>
                <div class="item">
                    <div class="item-user">
                        <img src="@/assets/team/user-2.png"/>
                        <div class="name">
                            <span>Steven Davis</span>
                            <div class="bg"/>
                        </div>
                        <div class="bg-color"/>
                        <div class="bg-name-color"/>
                    </div>
                    <div class="title">Head of Product Development</div>
                    <div class="note">Steven brings over a decade of experience in software development and product management. He oversees the creation and enhancement of BuildEffi AI's solutions, ensuring they meet industry needs. Steven holds a degree in Computer Science from UC Berkeley.</div>
                </div>
            </div>
            <div class="info">
                <div class="item">
                    <div class="item-user">
                        <img src="@/assets/team/user-3.png"/>
                        <div class="name">
                            <span>James Park</span>
                            <div class="bg"/>
                        </div>
                        <div class="bg-color"/>
                        <div class="bg-name-color"/>
                    </div>
                    <div class="title">Director of Operations</div>
                    <div class="note">With a background in civil engineering and project logistics, James ensures that BuildEffi AI's tools integrate seamlessly into client workflows. He has managed large-scale construction projects worldwide and holds a Master's in Construction Management from Columbia University.</div>
                </div>
                <div class="item">
                    <div class="item-user">
                        <img src="@/assets/team/user-4.png"/>
                        <div class="name">
                            <span>Oliver Martinez</span>
                            <div class="bg"/>
                        </div>
                        <div class="bg-color"/>
                        <div class="bg-name-color"/>
                    </div>
                    <div class="title">Head of Customer Success</div>
                    <div class="note">Oliver ensures that clients derive maximum value from BuildEffi AI's solutions. With over 10 years of experience in customer success and project consultancy, he works closely with businesses to tailor AI tools to their specific challenges. Oliver holds an MBA from INSEAD.</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "team"
    }
</script>

<style scoped lang="scss">
.banner {
    position: relative;
    height: 674px;

    > img {
        width: 100%;
        object-fit: contain;
    }

    .banner-text {
        position: absolute;
        top: 210px;
        left: 306px;
        font-size: 56px;
        font-weight: 700;
        line-height: 60px;
        color: #ffffff;
    }
}
.message-box {
    position: relative;
    width: 100%;
    height: 2188px;
    padding: 478px 248px 0 248px;
    z-index: 1;

    &::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1587px;
        background: url("../assets/team/bg.jpg") no-repeat 100%;
        z-index: -1;
    }

    .info,
    .first {
        display: flex;
        justify-content: space-between;
        width: 100%;

        .item {
            position: relative;
            width: 425px;
            .item-user {
                display: flex;
                align-items: flex-end;
                justify-content: center;
                position: relative;
                width: 330px;
                height: 452px;
                margin-bottom: 56px;
                > img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 330px;
                    height: 426px;
                    object-fit: contain;
                    z-index: 2;
                }

                .name {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    width: 313px;
                    height: 62px;
                    font-size: 20px;
                    font-weight: 700;
                    color: #ffffff;
                    z-index: 4;

                    .bg {
                        position: absolute;
                        top: 0;
                        left: 16px;
                        width: 100%;
                        height: 100%;
                        overflow: hidden;
                        transform: skew(-40deg, 0);
                        z-index: -1;

                        &::after {
                            content: "";
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            background: linear-gradient(128.08deg, #59B9F7 7.58%, #253FF1 90.01%);
                        }
                    }
                }

                .bg-color {
                    position: absolute;
                    right: -14px;
                    bottom: 40px;
                    width: 158px;
                    height: 250px;
                    background: linear-gradient(180deg, rgba(13, 227, 255, 0) 0%, #3461F3 100%);
                    z-index: 1;
                }

                .bg-name-color {
                    position: absolute;
                    bottom: -16px;
                    width: 250px;
                    height: 48px;
                    overflow: hidden;
                    transform: skew(-40deg, 0);

                    &::after {
                        content: "";
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(269.17deg, rgba(13, 227, 255, 0) 0%, #3461F3 169.29%);
                    }
                }
            }

            .title {
                font-size: 16px;
                font-weight: 400;
                line-height: 29px;
                color: #55B0F7;
                margin-bottom: 23px;
            }
            .note {
                font-size: 16px;
                font-weight: 400;
                line-height: 29px;
                color: #ffffff;
            }
        }
    }

    .first {
        position: absolute;
        top: -308px;
        left: 508px;
        width: 425px
    }
}
</style>